export default __webpack_public_path__ + "static/media/chevron-left.e44cb579.svg";